/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Customized Contact Section for client requests
*/

import { useState } from "react";

// firebase
import { collection, addDoc } from "firebase/firestore";
import { db } from "../../../../config";

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKInput from "components/MKInput";
import MKButton from "components/MKButton";
import MKTypography from "components/MKTypography";
import MKAlert from "components/MKAlert";
import { Select } from "@mui/material";

function ContactUsSection() {
  const initialFormState = {
    fullName: "",
    phone: "",
    email: "",
    serviceType: "Diamond Concrete Cutting",
  };

  const [formData, setFormData] = useState(initialFormState);
  const [submitting, setSubmitting] = useState(false);
  const [alert, setAlert] = useState({ type: null, message: "" });

  const handleChange = (event) => {
    const { name, value } = event.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validate = () => {
    const { fullName, phone, email, serviceType } = formData;

    if (!fullName.trim() || !phone.trim() || !email.trim() || !serviceType) {
      return "Please fill in all fields before submitting.";
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      return "Please enter a valid email address.";
    }

    return null;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    setAlert({ type: null, message: "" });

    const errorMessage = validate();
    if (errorMessage) {
      setAlert({ type: "error", message: errorMessage });
      return;
    }

    setSubmitting(true);

    try {
      const payload = {
        fullName: formData.fullName.trim(),
        phone: formData.phone.trim(),
        email: formData.email.trim().toLowerCase(),
        serviceType: formData.serviceType,
        createdAt: new Date().toISOString(),
      };

      const docRef = await addDoc(collection(db, "client_request"), payload);

      if (docRef && docRef.id) {
        setFormData(initialFormState);
        setAlert({
          type: "success",
          message: "Your request has been submitted successfully, We will be in touch soon.",
        });
      } else {
        setAlert({
          type: "error",
          message: "Submission failed. Please try again.",
        });
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Error submitting client request:", error);
      setAlert({
        type: "error",
        message: "Something went wrong while submitting your request. Please try again.",
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <MKBox component="section" pt={6} my={6}>
      <Container>
        <Grid container justifyContent="center">
          <Grid item xs={12} md={8}>
            <MKBox bgColor="white" borderRadius="xl" shadow="lg" p={3}>
              <MKTypography variant="h4" mb={1}>
                Request a service
              </MKTypography>
              <MKTypography variant="body2" color="text" mb={3}>
                Share your details and the type of service you need. Our team will contact you
                shortly.
              </MKTypography>

              {alert.type && alert.message && (
                <MKBox mb={2}>
                  <MKAlert color={alert.type === "success" ? "success" : "error"} dismissible>
                    {alert.message}
                  </MKAlert>
                </MKBox>
              )}

              <MKBox component="form" onSubmit={handleSubmit} autoComplete="off">
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <MKInput
                      name="fullName"
                      label="Full name"
                      variant="standard"
                      InputLabelProps={{ shrink: true }}
                      fullWidth
                      value={formData.fullName}
                      onChange={handleChange}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <MKInput
                      name="phone"
                      label="Phone number"
                      variant="standard"
                      InputLabelProps={{ shrink: true }}
                      fullWidth
                      value={formData.phone}
                      onChange={handleChange}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <MKInput
                      type="email"
                      name="email"
                      label="Email address"
                      variant="standard"
                      InputLabelProps={{ shrink: true }}
                      fullWidth
                      value={formData.email}
                      onChange={handleChange}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Select
                      // select
                      native
                      name="serviceType"
                      label="Service request type"
                      variant="standard"
                      InputLabelProps={{ shrink: true }}
                      fullWidth
                      value={formData.serviceType}
                      onChange={handleChange}
                    >
                      <option value="" disabled>
                        Select a service
                      </option>
                      <option value="Diamond Concrete Cutting">
                        Diamond Concrete Cutting and Core Drilling.
                      </option>
                      <option value="Screeding">Screeding</option>
                      <option value="Site Handover Cleaning"> Site Handover Cleaning </option>
                    </Select>
                  </Grid>
                  <Grid item xs={12} mt={2}>
                    <MKButton type="submit" variant="gradient" color="info" disabled={submitting}>
                      {submitting ? "Submitting..." : "Submit request"}
                    </MKButton>
                  </Grid>
                </Grid>
              </MKBox>
            </MKBox>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default ContactUsSection;
